module.exports = __webpack_public_path__ + "img/alleenlijn.0e0b506d.jpg";